import { getWhiteLabel, defaultWhiteLabel } from './index'

export const APP_BRANDING_KEY = 'app_branding'

export const getWhiteLabelInfo = (app_branding: string) => {
  if (app_branding) {
    return getWhiteLabel({ app_branding })
  } else {
    return defaultWhiteLabel
  }
}
